/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\Content\LoadingScreen\LoadingScreen.tsx
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Wednesday March 29th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday March 29th 2023 2:28:48 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import Spinner from "react-bootstrap/Spinner";

type LoadingScreenProps = {
    width?: string;
    height?: string;
    borderWidth?: string;
    color?: string;
}

function LoadingScreen(props: LoadingScreenProps ) {
    return (
        <Spinner animation="border"
        style={{
            width: `${props?.width ?? "20vh"}`,
            height: `${props?.height ?? "20vh"}`,
            borderWidth: `${props?.borderWidth ?? "20px"}`,
            color: `${props?.color ?? "var(--root-colors-third)"}`
        }}
        />
    );
};

export default LoadingScreen;
